import { DateTime } from 'luxon';

import { transactionsTransformers } from '../transactions';
import type { TransactionProps } from '../transactions/transactionsTypes';
import {
  type ScheduledTransaction,
  type ScheduledTransactionType,
  mkScheduledTransaction,
} from './scheduledTransactionsTypes';

// request transform
export const transformScheduledTransactionToRequestData = (
  resource: ScheduledTransaction | ScheduledTransactionType | null | undefined,
) => ({
  ...(resource && 'toJS' in resource ? (resource.toJS() as ScheduledTransactionType) : resource),
  ...(resource?.transaction && {
    transaction: transactionsTransformers.transformTransactionToRequestData(resource.transaction),
  }),
  userModifiedAt: DateTime.local().toISO(), // so QCS knows how to resolve race-condition conflicts,
});

// response transform
export const transformDataToScheduledTransaction = (
  data: { transaction?: TransactionProps | null } | null | undefined,
) =>
  mkScheduledTransaction({
    ...data,
    ...{ type: undefined },
    transaction: data?.transaction
      ? transactionsTransformers.transformQcsTransactionToTransaction(data.transaction)
      : null,
  });
